import React, { useEffect, useState } from "react";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import TextField from "../../Utils/FormInputs/TextField";
import { removeTime } from "../../Utils/titleCaseFunction";
import SelectInput from "../../Utils/FormInputs/SelectInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { useNewWholeSaleReceipt } from "./CustomHooks/useNewWholeSaleReceipt";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { connect } from "react-redux";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import DetailsDialog from "../../Utils/Dialog/DetailsDialog";
import { RowCustomerForm } from "../Customer/CustomerForm";
import InvoicePrintDialog from "./InvoicePrintDialog";
import ProductSearch from "../../Utils/FormInputs/ProductSearch";
import { BackButton } from "../../Utils/FormInputs/BackButton";

import {
  ErrorMessage,
  RightAlignedContainer,
} from "../../Utils/styledComponents";
// import {
//   AutoCompleteMedicine,
//   SelectItem,
// } from "../../Utils/FormInputs/AutoCompleteInput";
import {
  SelectItem,
  AutoCompleteUnControlled,
  AutoCompleteMedicine,
} from "../../Utils/FormInputs/AutoCompleteInput";
import Alert from "@material-ui/lab/Alert";
import { usePrint } from "../../Utils/Template/usePrint";
import { SalesReceiptTemplate } from "./SalesReceiptTemplate";
import { Link } from "react-router-dom";
import { validateCurrentDate } from "../../Utils/ConvertDate";
import { BlockNavigationComponent } from "../../Utils/ReusableComponents/BlockNavigationComponent";
import ExpiryPopup from "./ExpiryPopup";
import CustomDialog from "../../Utils/Dialog/CustomDialog";
import Textarea from "../../Utils/FormInputs/Textarea";
import './InvoiceTable.css';

/**
 * Component to return the UI for the New Sales Receipt
 * @param {*} param0
 * @returns
 */
function Dispensar({ actions, snackbars, match: { params } }) {
  const { invoice_number ,saletype} = params;

  const {
    submitted,
    stateVariables,
    openDialog,
    isPending,
    handleCloseDialog,
    handleSaveReceipt,
    handleCloseSnackbar,
    receiptData,
    handleViewReceipt,
    saveDispensarInvoice,
  } = useNewWholeSaleReceipt(actions, invoice_number,saletype);

  const {
    customer,
    rows,
    state,
    customerProps,
    handleClickCustomer,
    paytype,
    totals,
    customers,
    drugs,
    handleChangeBatch,
    handleAddRow,
    handleRetrieveCustomerInfo,
    handleChangePaymentMethod,
    handleChange,
    handleChangeBalance,
    handleChangeFormFields,
    handleRemoveSpecificRow,
    handleChangeQuantity,
    handleRetrieveDrugs,
    handleClickDrug,
    payTypes,
    isBlocking,
    isOpen,
    expiredDrugReason,
    showExpiredDrugReasonInput,
    showExpiredDrugDialog,
    openExpiredDrugReasonInput,
    closeExpiredDrugReasonInput,
    openExpiredDrugDialog,
    closeExpiredDrugDialog,
    handleChangeExpiredDrugReason,
    handleChangeDiscount,
    handleAddFourRows,
    handleChangeRate,
  } = stateVariables;

  const { paid_amount, change, due_amount, n_total } = totals;

  const {
    openCustomerDialog,
    handleOpenCustomerDialog,
    handleCloseCustomerDialog,
  } = customerProps;

  const { invoice_date } = state;

  const allCustomers = !customers ? [] : customers;

  const allDrugs = !drugs ? [] : drugs;

  const { open, variant, message } = snackbars;

  const { handlePrint, componentRef } = usePrint("");


  useEffect(() => {
    if (!openDialog) {
      return;
    }
    const listener = (event) => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        // console.log("Enter key was pressed. Run your function.");
        event.preventDefault();
        handlePrint();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [openDialog]);

  const validate_invoice_date = validateCurrentDate(invoice_date);

  const buttons = (
    <>
      <button
        onClick={
          showExpiredDrugReasonInput
            ? closeExpiredDrugDialog
            : openExpiredDrugReasonInput
        }
        type="button"
        className="btn btn-danger btn-sm"
      >
        {showExpiredDrugReasonInput ? "Submit" : "Yes"}
      </button>

      {/* <button
        onClick={closeExpiredDrugDialog}
        type="button"
        className="btn btn-sm pharmacy-gray-btn"
      >
        No
      </button> */}
    </>
  );



return (
  <div data-testid="new-sales-receipt">
    {/* Dashboard Header */}
    <ReusableDashboardHeader
      component="New Receipt"
      heading="Sales"
      subHeading={saletype === "wholesale" ? "Business Sale Receipt" : "Customer Sale Receipt"}
      link={history.location.pathname}
    />

    {/* Snackbar */}
    <PharmacySnackbar
      open={open}
      variant={variant}
      message={message}
      handleCloseBar={handleCloseSnackbar}
    />

    {/* Back Button */}
    <div className="mb-4">
      <BackButton text="Pending Approvals" to="/pendingapproval" />
    </div>

    {/* Customer Dialog */}
    <DetailsDialog
      title="New Customer"
      openDialog={openCustomerDialog}
      handleClose={handleCloseCustomerDialog}
    >
      <RowCustomerForm {...customerProps} />
    </DetailsDialog>

    {/* Hidden print component */}
    <div style={{ display: "none" }}>
      <div ref={componentRef} className="card styled-pos-card">
        <SalesReceiptTemplate {...receiptData} />
      </div>
    </div>

    {/* Navigation blocker */}
    <BlockNavigationComponent
      when={isBlocking}
      shouldBlockNavigation={() => isBlocking}
      navigate={(path) => history.push(path)}
    />

    {/* Invoice Print Dialog */}
    <InvoicePrintDialog
      text="receipt"
      openDialog={openDialog}
      handleCloseDialog={handleCloseDialog}
      message="Receipt"
    >
      <RightAlignedContainer>
        <button onClick={handlePrint} type="button" className="btn pharmacy-amber-btn mr-3">
          Print
        </button>

        <button onClick={handleViewReceipt} type="button" className="btn pharmacy-info-btn mr-3">
          Preview
        </button>

        <Link to="/pendingapproval">
          <button type="button" className="btn pharmacy-grey-btn">
            No
          </button>
        </Link>
      </RightAlignedContainer>
    </InvoicePrintDialog>

    {/* Receipt container */}
    <div className="receipt-container">
      <div className="text-md-right mt-4 mb-5">
        <button
          data-testid="quick_add_customer"
          type="button"
          className="btn btn-sm pharmacy-info-btn"
          onClick={() => handleOpenCustomerDialog("")}
        >
          Quick Add Customer
        </button>
      </div>

      <ProductSearch />
      {" "}
      <br></br>
      

      <form
        onSubmit={saveDispensarInvoice}
        autoComplete="off"
        data-testid="new-sales-receipt-form"
      >
        {/* Left and Right Columns */}
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-6">
            {/* Invoice Date */}
            <Form.Group as={Row}>
              <Col sm="3">
                <Label name="Date" />
              </Col>
              <Col sm="8">
                <TextField
                  type="date"
                  value={invoice_date}
                  name="invoice_date"
                  onChange={handleChangeFormFields}
                />
                {submitted && !invoice_date && <ErrorMessage>Invoice date is required</ErrorMessage>}
                {/* {validate_invoice_date === false && (
                  <ErrorMessage>Please select a valid date, you selected a date in the future</ErrorMessage>
                )} */}
              </Col>
            </Form.Group>

            {/* Customer Selection */}
            <Form.Group as={Row}>
              <Col sm="3">
                <Label name="Customer" />
              </Col>
              <Col sm="8" style={{ margin: 0 }}>
                <AutoCompleteUnControlled
                  options={allCustomers}
                  submitted={submitted}
                  handleChange={handleRetrieveCustomerInfo}
                  medicine_value={customer}
                  label_text="customer_name"
                  value_text="customer_id"
                  handleProductData={handleClickCustomer}
                  testId="customer"
                  id="customer"
                  placeholder="Type Customer Name"
                  errorMsg="Enter Customer Name"
                  reset={saletype}
                />
              </Col>
            </Form.Group>
          </div>

          {/* Right Column */}
          <div className="col-lg-6">
            {/* Total Amount */}
            <Form.Group as={Row}>
              <Col sm="3">
                <Label name="Total Amount" />
              </Col>
              <Col sm="9">
                <TextField
                  type="number"
                  name="n_total"
                  placeholder="0.00"
                  data-testid="total_amount"
                  value={n_total}
                  readOnly
                />
              </Col>
            </Form.Group>

            {/* Due Amount */}
            <Form.Group as={Row}>
              <Col sm="3">
                <Label name="Due Amount" />
              </Col>
              <Col sm="9">
                <TextField
                  type="number"
                  name="due_amount"
                  placeholder="0.00"
                  data-testid="due_amount"
                  value={due_amount}
                  readOnly
                />
              </Col>
            </Form.Group>
          </div>
        </div>

        {/* Alert if no products */}
        {submitted && rows.length <= 0 && (
          <div className="mb-4">
            <Alert severity="error">Please add a product before submitting</Alert>
          </div>
        )}

        {/* Expired Drug Dialog */}
        <CustomDialog
          open={showExpiredDrugDialog}
          handleClose={closeExpiredDrugDialog}
          title="Drug about to Expire!"
          buttons={buttons}
        >
          {showExpiredDrugReasonInput ? (
            <>
              <Label name="Reason for proceeding:" />
              <Textarea
                data-testid="expired_drug_reason"
                name="reason for expired drug"
                value={expiredDrugReason}
                placeholder="Enter a valid reason"
                id="details"
                onChange={handleChangeExpiredDrugReason}
              />
            </>
          ) : (
            <Label name="Are you sure you want to proceed with this action?" />
          )}
        </CustomDialog>

        {/* Products Table */}
        <div className="custom-table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Item Info</th>
                  <th>Total Stock</th>
                  <th>Batch</th>
                  <th>Qty Avail</th>
                  <th>Expiry</th>
                  <th>Unit</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>Discount</th>
                  <th>Total Price</th>
                  <th>Action</th>
                </tr>
            </thead>

            <tbody>
              {rows.map((item, idx) => (
                <tr key={item.uuid_id}>
                  <td width="15%">
                    {/* <AutoCompleteUnControlled
                     options={allDrugs}
                     submitted={submitted}
                     idx={idx}
                     handleChange={handleRetrieveDrugs}
                     label_text="label"
                     medicine_value={{
                       label: rows[idx].product_name,
                       value: rows[idx].product_id,
                       generic_name: rows[idx].generic_name,
                     }}
                     id="product_name"
                     testId={"product-" + idx}
                     value_text="value"
                     handleProductData={handleClickDrug}
                     placeholder="Type Product Name"
                     errorMsg="Enter Product Name"
                     data-testid={"product-" + idx}
                    /> */}
                     <AutoCompleteMedicine
                          options={allDrugs}
                          submitted={submitted}
                          idx={idx}
                          handleChange={handleRetrieveDrugs}
                          label_text="label"
                          medicine_value={{
                            label: rows[idx].product_name,
                            value: rows[idx].product_id,
                            generic_name: rows[idx].generic_name,
                          }}
                          id="product_name"
                          testId={"product-" + idx}
                          value_text="value"
                          handleProductData={handleClickDrug}
                          placeholder="Type Product Name"
                          errorMsg="Enter Product Name"
                          data-testid={"product-" + idx}
                          // readOnly
                        />
                  </td>
                  <td className="text-center">
                        {/* {item.product_name === "" ? "" : item.total_stock} */}
                        <TextField
                          type="text"
                          data-testid={"total_stock-" + idx}
                          name="total_stock"
                          value={item.product_name === "" ? 0: item.total_stock}
                          disabled={true}
                          placeholder="0.00"
                        />
                      </td>
                  {/* <td className="text-center">
                    <SelectItem
                      options={item?.batch_info?.map(({ batch_id, batch_details_id }) => ({
                        label:batch_id,
                        value:batch_details_id,
                      }))}
                      submitted={submitted}
                      idx={idx}
                      onChange={handleChangeBatch}
                      value={item.product_name ? ({value_text : item.batch_details_id ,label_text:item.batch_id}||item.batch_info[0]) : ""}
                      errorMsg="Enter Batch ID"
                      label_text="label"
                      value_text="value"
                    />
                  </td> */}
                  <td className="text-center">
                    <SelectItem
                      options={item?.batch_info?.map(({ batch_id, batch_details_id }) => ({
                        label: batch_id ?? "N/A",
                        value: batch_details_id,
                      }))}
                      submitted={submitted}
                      idx={idx}
                      onChange={handleChangeBatch} // pass only value
                      value={
                        item.batch_details_id
                          ? {
                              label:
                                item.batch_id?? "N/A",
                              value: item.batch_details_id,
                            }
                          : null
                      }
                      errorMsg="Enter Batch ID"
                      label_text="label"
                      value_text="value"
                    />
                  </td>


                  <td className="text-center">
                    <TextField
                      type="text"
                      name="available_quantity"
                      data-testid={"available_quantity-" + idx}
                      value={rows[idx]?.available_quantity}
                      disabled
                      placeholder="0.00"
                    />
                  </td>
                  <td className="text-center d-none d-md-table-cell">
                    <TextField
                      type="text"
                      data-testid={"expiry_date-" + idx}
                      value={rows[idx].expiry ? removeTime(rows[idx].expiry) : ""}
                      disabled
                    />
                  </td>
                  <td className="text-center">
                    <TextField
                      type="text"
                      name="unit"
                      data-testid={"product_unit-" + idx}
                      value={rows[idx].unit || ""}
                      disabled
                    />
                  </td>
                  <td className="text-center">
                    <TextField
                      type="number"
                      name="product_quantity"
                      data-testid={"product_quantity-" + idx}
                      value={rows[idx].product_quantity}
                      onChange={(e) => handleChangeQuantity(e, idx)}
                      submitted={submitted}
                      placeholder="0.00"
                    />
                    {submitted && !rows[idx].product_quantity && <div className="invalid-text">Enter the quantity</div>}
                    {submitted && item.isError && <div className="invalid-text">Quantity should be less than stock</div>}
                  </td>
                  <td className="text-right">
                    <TextField
                      type="number"
                      data-testid={"product_rate-" + idx}
                      name="product_rate"
                      onChange={(e) => handleChangeRate(e, idx)}
                      value={item.product_rate}
                      placeholder="0.00"
                    />
                    {submitted && item.isPriceLower && <div className="invalid-text">Price cannot be lower than original ({item.original_rate})</div>}
                  </td>
                  <td>{/* Discount logic */}</td>
                  <td className="text-right"> 
                    <TextField
                      type="text"
                      data-testid={"total_price-" + idx}
                      name="total_price"
                      value={rows[idx].total_price}
                      readOnly
                      placeholder="0.00"
                    />
                  </td>
                  <td>
                    <button type="button" data-testid={"delete-" + idx} className="btn btn-outline-danger btn-sm" onClick={() => handleRemoveSpecificRow(idx)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                    <input type="hidden" value={rows[idx].total_discount} className="total_discount dppr" name="total_discount" />
                  </td>
                </tr>
              ))}

              {/* Add Row Buttons */}
              <tr>
                <td colSpan={10}>
                  <button type="button" onClick={handleAddRow} className="btn pharmacy-gray-btn btn-sm">
                    Add another line
                  </button>
                  <button type="button" onClick={handleAddFourRows} className="btn pharmacy-gray-btn btn-sm ml-2">
                    Add four lines
                  </button>
                </td>
              </tr>
                              {/* Grand Total Row */}
              <tr>
                  <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>
                    Grand Total:
                  </td>
                  <td className="text-right">
                    <TextField
                      type="number"
                      data-testid="grand_total_price"
                      name="grand_total_price"
                      value={n_total}
                      placeholder="0.00"
                      readOnly
                      InputProps={{
                        style: { fontWeight: "bold", textAlign: "right" },
                      }}
                    />
                  </td>
                </tr>
            </tbody>
          </table>
        </div>

        {/* Submit Button */}
        <div className="text-md-right mt-3">
          <button data-testid="save_sale" type="submit" disabled={isPending} className="btn pharmacy-btn">
            {isPending ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  </div>
);
}
function mapStateToProps(state) {
  return {
    snackbars: state.snackbars,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dispensar);
